import { z } from 'zod';
// Standard pagination — used by every list endpoint. `page` is 1-based;
// callers compute `offset = (page - 1) * limit`.
export const paginationSchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
});
//# sourceMappingURL=pagination.schemas.js.map